import { render, staticRenderFns } from "./cell-translation-job-user.vue?vue&type=template&id=663b0362&scoped=true"
import script from "./cell-translation-job-user.ts?vue&type=script&lang=ts&external"
export * from "./cell-translation-job-user.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-translation-job-user.vue?vue&type=style&index=0&id=663b0362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b0362",
  null
  
)

export default component.exports